import React, { useContext, useState, useEffect } from 'react';
import { DataContext } from '../context/DataContext';
import Footer from "../components/Footer";

import HistorialCard from "./Historial-card";

/* Begin By Javi */
import Header from './Header';
import alertify from "alertifyjs";
import utils from "./../util";
import Grid from "./Movil/Grid-m";
import { Loader } from "../util/loader";
import { getStorage, getStorageList } from "../util/auth";
import { apiHistorial } from "../api";
/* End By Javi */

let codigo = 0;
const { isMobile } = utils
export const HistorialAcademico = () => {
  const { data, setData } = useContext(DataContext);
  const [historial, setHistorial] = useState({});
  /* Begin By Javi */
  const [Loading, setloading] = useState(true);
  const [alertMessage, setMessage] = useState("Notificación de Historial Academico");
  let dataStorage = getStorage("studientActive");
  let dataListStorage = getStorageList("studientList");
  const [_isMobile] = useState(isMobile());
  /* End By Javi */


  const getHistoryAcademic = () => {
    /* Begin By Javi */
    setloading(true);
    codigo =
      data == undefined || data.student == undefined
        ? dataStorage.Codigo
        : data.student.Codigo;
    const promise = apiHistorial.listar(codigo, alertMessage);
    promise.then((res) => {
      setloading(false);
      if (res != undefined) {
        setHistorial(res.programArray[0]);
      }
    });
    /* End By Javi */
  };

  useEffect(
    () => {
      /* Begin By Javi */
      setData({ ...data, students: dataListStorage, student: dataStorage });
      if (dataStorage.Codigo == undefined || data == undefined && dataListStorage.length != 1) {
        setloading(false);
        alertify
          .alert("Debe seleccionar un Estudiante", function () {
            window.location.href = "./home";
          })
          .setHeader(alertMessage);
        return;
      }
      /* End By Javi */
      getHistoryAcademic();
    },
    [setData],
    [setHistorial]
  );
  return (
    <div>
      {Loader(Loading)}
      {_isMobile ? (
        <>
          <div className="contend">
            <div className="text col-12">
              {data != undefined && data.student != undefined ? (
                <Header
                  objData={data}
                  Title={"Historial Academico"}
                  isMobile={_isMobile}
                  objActiveAlummno={getHistoryAcademic}
                />
              ) : (
                ""
              )}
              <Grid Active={"Historial"} objhistorial={historial} />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="contend">
            <div className="text col-12">
              <Header
                objData={data}
                Title={"Historial Academico"}
                objActiveAlummno={getHistoryAcademic}
              />
              <HistorialCard objhistorial={historial} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
